/* gl_textfield.module.js */

"use strict";

var angular = require("angular");

module.exports = angular.module("gl_textfield", []);


/* Generated Dependencies */
module.exports.directive("glTextfield", require('././directives/gl_textfield.directive.js'));